import React, { useEffect } from 'react';
import './DeleteConfirmModal.css';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, items }) => {
  const itemCount = items ? items.length : 0;
  const itemType = itemCount === 1 
    ? (items[0]?.isFolder ? 'folder' : 'file')
    : 'items';
  const itemName = itemCount === 1 ? items[0]?.name : null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Enter' || event.code === 'Enter' || event.code === 'NumpadEnter') {
        event.preventDefault();
        handleConfirm();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose, onConfirm]);

  if (!isOpen) return null;

  return (
    <div className="delete-confirm-modal-overlay" onClick={handleCancel}>
      <div className="delete-confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="delete-confirm-modal-header">
          <i className="fas fa-exclamation-triangle"></i>
          <h2>Delete {itemType === 'items' ? 'Items' : itemType === 'folder' ? 'Folder' : 'File'}?</h2>
        </div>
        
        <div className="delete-confirm-modal-content">
          <p>
            Are you sure you want to delete {itemCount === 1 ? (
              <strong>"{itemName}"</strong>
            ) : (
              <strong>{itemCount} {itemType}</strong>
            )}?
          </p>
        </div>

        <div className="delete-confirm-modal-footer">
          <button 
            className="delete-confirm-btn cancel-btn" 
            style={{ background: '#0000ff00' }}
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button 
            className="delete-confirm-btn confirm-btn" 
            onClick={handleConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;

